import { useState } from 'react'
import {
  Button,
  Card,
  Col,
  Form,
  Input,
  Row,
  Select,
  Title,
} from 'components/common'
import { staticCustomerType } from 'lib/constants'
import {
  CustomerSelectModal,
  CustomerSelectModalProps,
} from 'components/bookings/modals'

export interface FilterFormElement {
  first_name?: string
  last_name?: string
  email?: string
  phone?: string
  type?: string
}

export interface CustomerSearchCardProps
  extends Omit<CustomerSelectModalProps, 'onClose'> {
  title: string
  onSearch: (values: FilterFormElement) => void
}

export const CustomerSearchCard = ({
  data,
  loading,
  title,
  onSearch,
  onSelect,
}: CustomerSearchCardProps): JSX.Element => {
  const [form] = Form.useForm<FilterFormElement>()
  const [isVisible, setIsVisible] = useState<boolean>(false)
  const [customerType, setCustomerType] = useState<string>('')
  return (
    <Card shadow>
      <Title level={5}>{title}</Title>
      <Form form={form} component="form" onFinish={onSearch}>
        <Row justify="space-between">
          <Col span={11}>
            <Form.Item
              name="last_name"
              label={
                customerType === staticCustomerType.corporate
                  ? '担当者 姓'
                  : '姓'
              }
            >
              <Input autoComplete="off" />
            </Form.Item>
          </Col>
          <Col span={11}>
            <Form.Item
              name="first_name"
              label={
                customerType === staticCustomerType.corporate
                  ? '担当者 名'
                  : '名'
              }
            >
              <Input autoComplete="off" />
            </Form.Item>
          </Col>
        </Row>
        {customerType === staticCustomerType.corporate && (
          <Form.Item name="corporation_name" label="法人・団体名">
            <Input autoComplete="off" />
          </Form.Item>
        )}
        <Form.Item
          name="type"
          label="顧客タイプ"
          initialValue={staticCustomerType.personal}
          rules={[{ required: true }]}
        >
          <Select
            onChange={(value) => {
              if (value === staticCustomerType.corporate) {
                setCustomerType(staticCustomerType.corporate)
              } else {
                setCustomerType(staticCustomerType.personal)
              }
            }}
          >
            <Select.Option key={staticCustomerType.personal}>
              個人
            </Select.Option>
            <Select.Option key={staticCustomerType.corporate}>
              法人・団体
            </Select.Option>
          </Select>
        </Form.Item>
        <Form.Item name="phone" label="電話番号">
          <Input autoComplete="off" />
        </Form.Item>
        <Form.Item name="email" label="メールアドレス">
          <Input autoComplete="off" />
        </Form.Item>
        <Form.Item>
          <Button htmlType="submit" onClick={() => setIsVisible(true)}>
            検索
          </Button>
        </Form.Item>
      </Form>
      <CustomerSelectModal
        customerType={customerType}
        visible={isVisible}
        data={data}
        onClose={setIsVisible}
        loading={loading}
        onSelect={onSelect}
      />
    </Card>
  )
}
